module.exports = __webpack_public_path__ + "img/Shield_w_Background_2x.e4825eb.png";